import { PhoneNumberTemplateBase } from "./PhoneNumberTemplateBase";

export function initPhoneNumberTemplate(controlId: string) {
    PhoneNumberTemplateBase.init(controlId);
}
